import React from 'react';
import {useLocation} from 'react-router-dom';
import {EventTracker} from '../components/GoogleAnalytics';
import '../styles/process.page.scss';
import { Container, Row, Col, Image, Button } from 'react-bootstrap';
import PageTitle from '../components/PageTitle';

export default function Process({ l }) {
    return (
        <>
            <Container>
                <PageTitle title={l.pageTitle} intro={l.pageTitleText} />
                {/* <BenefitsForParticipants
                    title={l.participantsTitle}
                    img={l.participantsImg}
                    imgAlt={l.participantsImgAlt}
                    text={l.participantsText} /> */}
                {/* <hr className="my-2 my-md-5" /> */}
                <BenefitsForWinners
                    title={l.winnersTitle}
                    intro={l.winnersIntro}
                    benefits={l.winnersBenefits} />
                <hr className="my-2 my-md-5" />
                <CompetitionProcess l={l} />
                <Row className="mt-1 mt-md-3">
                    <Col xs={12} md={5}>
                        <h3 className="bold">{l.pilotTitle}</h3>
                        <p dangerouslySetInnerHTML={{ __html: l.pilotText }}></p>
                    </Col>
                    <Col xs={12} md={{ span: 5, offset: 1 }}>
                        <h3 className="bold">{l.fundingTitle}</h3>
                        <p dangerouslySetInnerHTML={{ __html: l.fundingText }}></p>
                    </Col>
                </Row>
            </Container>
            <Container fluid className="bg-primary mt-5">
                <Container>
                    <Download l={l} />
                </Container>
            </Container>
        </>
    )
}

function BenefitsForParticipants({ title, img, imgAlt, text }) {
    return (
        <Row>
            <Col xs={12} className="mb-2">
                <h2>
                    {title}
                </h2>
            </Col>
            <Col xs={12} md={6} >
                <Image fluid src={img} alt={imgAlt} />
            </Col>
            <Col xs={12} md={6}>
                <p dangerouslySetInnerHTML={{ __html: text }}></p>
            </Col>
        </Row>
    )
}

function BenefitsForWinners({ title, intro, benefits }) {
    return (
        <>
            <div>
                <h2>
                    {title}
                </h2>
            </div>
            <Row>
                <Col xs={12} md={6}>
                    <p>{intro}</p>
                </Col>
                <Col md={6}></Col>
                {benefits.map(benefit => renderWinnerBenefit(benefit))}
            </Row>
        </>
    )
}

function renderWinnerBenefit({ iconSrc, iconAlt, title, text }) {
    return (
        <Col xs={12} md={3} className="mt-4" key={`benefit-${title}`}>
            <Image fluid src={iconSrc} alt={iconAlt} style={{ maxWidth: '145px' }} />
            <h3 className="h5 mt-2">{title}</h3>
            <p dangerouslySetInnerHTML={{ __html: text }}></p>
        </Col>
    )
}

function CompetitionProcess({ l }) {
    return (
        <Row className="mt-1 mt-md-3">
            <Col xs={12}>
                <h2>
                    {l.processTitle}
                </h2>
            </Col>
            <Col xs={12} md={6}>
                <p dangerouslySetInnerHTML={{ __html: l.processText }}></p>
            </Col>
            <Container>
                <Row>
                    {l.phases.map((phase, i) => (
                        <PhaseCard phase={phase} key={`phase-${i}`} />
                    ))}
                </Row>
            </Container>
        </Row>
    )
}

function PhaseCard({ phase }) {
    console.log(phase.triggerDate, Date.now())
    return (
        <Col xs={12} md={6} lg={4} className="py-2">
            <div className={phase.triggerDate < Date.now() ? 'p-2 h-100 bg-primary text-white' : 'p-2 h-100 bg-secondary'} style={{ minHeight: '320px' }}>
                <h3 className="h2">{phase.date}</h3>
                <h4>
                    {phase.title}
                </h4>
                <p dangerouslySetInnerHTML={{ __html: phase.text }}></p>
            </div>
        </Col>
    )
}

function Download({ l }) {
    const currentLocation = useLocation().pathname;
    const category = 'download';
    const action = `downloaded challenge manual on ${currentLocation}`;
    if (!l.downloadTitle) {return null}
    return (
        <Row className="justify-content-center text-center py-2 py-md-5">
            <Col xs={12} md={6}>
                <div className="h3 bold text-white">
                    {l.downloadTitle}
                </div>
                <div>
                    <Button href={l.challengeManualUrl}
                        target="_blank"
                        variant="secondary"
                        className="mt-1 mt-md-3 text-uppercase"
                        onClick={() => EventTracker(category, action)}>
                        {l.downloadButtonText}
                    </Button>
                </div>
            </Col>
        </Row>
    )
}